"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.Paragraph = ({ children, className = '', size = 'md' }) => {
    return React.createElement("p", { className: `clp-paragraph ${className} clp-paragraph_size_${size}` }, children);
};
//# sourceMappingURL=Paragraph.js.map